import {
    ADD_QUEUE,
    SET_QUEUE,
    SET_BUTTON_ENABLED,
    SET_VISIBILITY,
    BUTTON_CLICKED,
} from './constants'

export function addQueue(name, buttonEnabled = false) {
    return {
        type: ADD_QUEUE,
        payload: {
            name,
            buttonEnabled,
        },
    }
}

export function setQueue(name) {
    return {
        type: SET_QUEUE,
        payload: name,
    }
}

export function setButtonEnabled(enabled) {
    return {
        type: SET_BUTTON_ENABLED,
        payload: enabled,
    }
}

export function setVisibility(visible) {
    return {
        type: SET_VISIBILITY,
        payload: visible,
    }
}

export function buttonClicked() {
    return {
        type: BUTTON_CLICKED,
    }
}



// WEBPACK FOOTER //
// ./src/features/Toaster/data/queue/actions.js